module.exports = __webpack_public_path__ + "static/patagonia-f6e2e4d170cc70d93d30f22d83548c8a.png";